import type { DiscoveryLink, PaperWithRole } from "@/types/paper";
import { describeRelation } from "@/lib/provenance";

interface Props {
  links: DiscoveryLink[] | null | undefined;
  /** id → paper for this concept (seeds + found papers). */
  paperIndex: Map<string, PaperWithRole>;
}

/** "How PaperChase found this" — makes the seed → trawl relationship visible. */
export function DiscoveryProvenance({ links, paperIndex }: Props) {
  if (!links || links.length === 0) return null;
  return (
    <div className="space-y-1">
      <p className="text-[10px] uppercase tracking-wide font-semibold text-muted-foreground/70">
        How PaperChase found this
      </p>
      <ul className="space-y-0.5">
        {links.map((l) => {
          const parent = paperIndex.get(l.parent_paper_id);
          const isSeed = parent?.paper_role === "foundational";
          return (
            <li key={`${l.parent_paper_id}|${l.relation}`} className="text-xs text-muted-foreground/90 leading-snug">
              {describeRelation(l.relation)}{" "}
              <span className="text-foreground/90">{parent?.title ?? "a paper no longer in this concept"}</span>
              {isSeed && (
                <span className="ml-1 rounded bg-blue-500/15 px-1 py-px text-[10px] text-blue-400">Seed</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
